export const GET_ALL_JOBS = 'GET_ALL_JOBS';
export const SAVE_ALL_JOBS = 'SAVE_ALL_JOBS';
export const GET_JOB_FUNCTION = 'GET_JOB_FUNCTION';
export const SAVE_JOB_FUNCTION = 'SAVE_JOB_FUNCTION';
export const POST_JOB_FUNCTION = 'POST_JOB_FUNCTION';
export const DELETE_JOB_FUNCTION = 'DELETE_JOB_FUNCTION';
export const DELETE_JOB = 'DELETE_JOB';
export const CREATE_JOB = 'CREATE_JOB';
export const RESET_SCHEDULE = 'RESET_SCHEDULE'